import deleteService from "../deleteService";
import getService from "../getService";
import postService from "../postService";
import putService from "../putService";

const CONFIG_API_URL =
    process.env.REACT_APP_API_BASE_URL || "http://20.126.75.78/naptin/api/v1/";


export default class CenterService {
    static async getCenters( param : string ) {
        const response = await getService.get(`${CONFIG_API_URL}centres${param}`);
        const data: any = response.data;
        return data;
    }
   
    
    static async getCenter(uuid: string | undefined) {
        const response = await getService.get(`${CONFIG_API_URL}centres/${uuid}`);
        const data: any = response.data;
        return data;
    }

    static async createCenter(data: any) {
        const response = await postService.post(`${CONFIG_API_URL}centres`, data);
        return response.data;

    }

    static async updateBadge(data: any, uuid: string | undefined) {
        const response = await putService.put(`${CONFIG_API_URL}centres/${uuid}`, data);
        return response.data;

    }
    static async deleteCenter(uuid: string | undefined) {
        const response = await deleteService.delete(`${CONFIG_API_URL}centres/${uuid}`);
        const data: any = response.data;
        return data;
    }
}
